import { IRequirementRowPadding } from 'app/models/Placement/PlacementSummary';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRequirementFilter } from '../../../Helpers/requirementFilter';
import {
  selectBookingInfo,
  selectEditableFields,
} from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { ConfirmationCheckbox } from '../../TableComponents/Confirmations/ConfirmationCheckbox';
import { ConfirmationsRow } from '../../TableComponents/Confirmations/ConfirmationsTable';

export const FinalizedByQS = ({ hasRequirements }: IRequirementRowPadding) => {
  const { t } = useTranslation();
  const { finalizedByQs: initialValue } = useSelector(selectEditableFields);
  const {
    credentialing: { finalizedByQs },
    requirementFilter,
  } = useSelector(selectBookingInfo);
  const { control, formState: { errors } } = useFormContext();

  const { display } = useRequirementFilter('booking-credentialing', requirementFilter, finalizedByQs?.type);

  return display ? (
    <Controller
      control={control}
      name="finalizedByQs"
      render={({ field: { onChange, onBlur, value, name, ref, ...rest } }) => (
        <ConfirmationsRow
          id="placement-booking-credentialing-finalized-by-qs"
          lastUpdatedBy={value?.lastUpdatedBy}
          lastUpdatedDate={value?.lastUpdatedAt}
          requirement={finalizedByQs?.type}
          hasOtherRequirements={hasRequirements}
          controlComponent={
            <ConfirmationCheckbox
              label={t('placement.profile.summary.booking.credentialing.finalizedByQS')}
              defaultState={initialValue}
              disabled
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              name={name}
              ref={ref}
            />
          }
        />
      )}
    />
  ) : null;
};
